// extracted by mini-css-extract-plugin
export default {"section":"profile-UserSettings__section--SuBw3"};